let _ = require("ES/lib/lodash");

module.exports = function(speaker){
    let to_save = {};
    _.each(speaker.todolists, function(list){
        to_save[list.id] = {
            name: list.listname,
            items: {}
        };
        _.each(list.masters, function(item, id){
            to_save[list.id].items[id] = {
                activateonstatus: item.activateonstatus,
                assignedto: item.assignedto,
                description: item.description,
                duebasedon: item.duebasedon,
                duedelta: item.duedelta,
                vieworder: item.vieworder
            };
        });
    });
    return to_save;
};



// WEBPACK FOOTER //
// ./src/components/account_settings/action_lists/DisplaylistSpeaker_to_actionlistSaveData.js